import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-menu-toggle-icon',
  standalone: true,
  template: `
    <svg
      viewBox="0 0 32 32"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      [class.open]="open"
      [style.transition-duration.ms]="duration"
      aria-hidden="true">
      <path
        class="menu-toggle-arc"
        [style.transition-duration.ms]="duration"
        d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22" />
      <path d="M7 16 27 16" />
    </svg>
  `,
  styles: [`
    :host {
      display: inline-flex;
      line-height: 0;
    }

    svg {
      width: 1.35rem;
      height: 1.35rem;
      transition-property: transform;
      transition-timing-function: ease-in-out;
    }

    svg.open {
      transform: rotate(-45deg);
    }

    .menu-toggle-arc {
      transition-property: stroke-dasharray, stroke-dashoffset;
      transition-timing-function: ease-in-out;
      stroke-dasharray: 12 63;
    }

    svg.open .menu-toggle-arc {
      stroke-dasharray: 20 300;
      stroke-dashoffset: -32.42px;
    }
  `],
})
export class MenuToggleIconComponent {
  @Input() open = false;
  @Input() duration = 500;
}
